import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';

export const TotalVaccinationByYear = () => {
    const { chartData } = useVaccinationChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual do Total de Vacinação'}
            horizontal={false}
            subtitles={chartData?.totalVaccinationByYear?.map((item) => item.description)}
            values={chartData?.totalVaccinationByYear?.map((item) => item.total  ||  0)}
        />
    );
};
